import { forwardRef, useEffect } from 'react';
import { useGesture } from 'use-gesture-pack';
import { scale, translate, compose, toString, identity, fromString } from 'transformation-matrix';
import { GetMaxZIndex } from '../utils/UtilitaryFunctions';

const CustomMultitouchComponent = forwardRef((props, ref) => {

    //var ref = useRef();
    const { 
        dragGesture = false, swipeGesture = true, multiGesture = true, touchAndHoldGesture = true, pinchGesture = true, tapGesture = true, options, children, x = 0, y = 0,
        open = true, reposition = false, dragBox = null, dragGestureMouse = false, scrollGestureMouse = false, isOpenCanvasRef
    } = props
    const { appWidth = 3840, appHeight = 2160, minScale = 0.5, maxScale = 50, touchAndHoldDuration = 1500, bringToFront = true } = options ? options : {};


    // let lastMouseX = 0;
    // let lastMouseY = 0;
    // let velocity = { x: 0, y: 0 };
    let pinched = false;


    useGesture(
        {
            onDragStart: () => {
                props.onDragStart?.();
                StopAnimation();
            },
            onDrag: ({ dx, dy, point }) => {
                var mat = identity();

                if (ref.current.style.transform !== '') {
                    mat = fromString(ref.current.style.transform);
                }

                var trans = translate(dx, dy);
                var final = compose(trans, mat);

                if(isOpenCanvasRef && !isOpenCanvasRef.current){
                    ref.current.style.transform = toString(final);
                }
            },
            onPinchStart: () => {
                pinched = true;
                props.onPinchStart?.();
                StopAnimation();
            },
            onPinch: ({ dx, dy, angle, centerPoint, scale_factor, transformationPoint, points }) => {
                var mat = identity();

                if (ref.current.style.transform !== '') {
                    mat = fromString(ref.current.style.transform);
                }

                var trans = translate(dx, dy);
                //var rotate = rotateDEG(angle, transformationPoint.x, transformationPoint.y);

                var currentScale = GetMatrixScale(mat)

                if (currentScale * scale_factor > maxScale || currentScale * scale_factor < minScale) {
                    if (currentScale * scale_factor < minScale && props.onMinScaleReached) {
                        props.onMinScaleReached();

                    }
                    scale_factor = 1;
                }

                var scaleFunction = scale(scale_factor, scale_factor, transformationPoint.x, transformationPoint.y);

                //var final = compose(rotate, scaleFunction, trans, mat);
                var final = compose(scaleFunction, trans, mat);

                ref.current.style.transform = toString(final);

                props.onPinch?.(currentScale);
            },
            onMultiStart: () => {
                StopAnimation();
            },
            onMulti: ({ dx, dy }) => {
                if (multiGesture === true) {
                    var mat = identity();

                    if (ref.current.style.transform !== '') {
                        mat = fromString(ref.current.style.transform);
                    }

                    var trans = translate(dx, dy);
                    var final = compose(trans, mat);
                    ref.current.style.transform = toString(final);
                }
            },
            onSwipe: (direction) => {
                props.onSwipe?.(direction);
            },
            onDragInside: (options) => {
                props.onDragInside?.(options);
            },
            onTouchAndHoldEnd: () => {
                props.onTouchAndHoldFinished?.();
            },
            onGestureEnded: () => {
                if (pinched) {
                    props.onGestureEnded?.();
                }
                pinched = false;
                if (ref.current) {
                    CheckIfOutsideBounds(ref, appWidth, appHeight);
                }
            },
            onTapped: () => {
                props.onTapped?.();
            }
        },
        {
            target: ref,
            dragGesture,
            swipeGesture,
            pinchGesture,
            multiGesture,
            tapGesture,
            touchAndHoldGesture,
            appWidth,
            appHeight,
            touchAndHoldDuration,
            bringToFront,
            dragGestureMouse,
            dragBox,
            scrollGestureMouse
        }
    );

    function StopAnimation() {
        var computedStyle = window.getComputedStyle(ref.current);
        var aux_transform = computedStyle.getPropertyValue('transform');
        ref.current.style.transform = aux_transform;
        ref.current.style.transition = "";
    }

    // function ApplyInertia(target, velocity, appWidth, appHeight) {
    //     var mat = fromString(target.current.style.transform);
    //     var trans = translate(velocity.x, velocity.y);


    //     var length = Math.sqrt(velocity.x * velocity.x + velocity.y * velocity.y);

    //     var animDuration = length * 300 < 300 ? 300 : (length * 300 > 800 ? 800 : length * 300);

    //     target.current.style.transition = "transform " + animDuration + "ms";
    //     target.current.style.transitionTimingFunction = "ease-out";

    //     var final = compose(trans, mat);
    //     target.current.style.transform = toString(final);


    //     setTimeout(() => {
    //         CheckIfOutsideBounds(target, appWidth, appHeight);
    //     }, animDuration);
    // }

    function CheckIfOutsideBounds(target, appWidth, appHeight) {
        if (target.current) {
            var oxDivider = window.innerWidth / appWidth;
            var oyDivider = window.innerHeight / appHeight;
            target.current.style.transition = "";
            //const { width, height, x, y } = target.current.getBoundingClientRect();
            const { width, height, x, y } = target.current.childNodes[0].getBoundingClientRect();

            if (x + width / 2 < 0) {

                target.current.style.transition = "transform 500ms";
                target.current.style.transitionTimingFunction = "ease-in";

                var mat = fromString(target.current.style.transform);
                var trans = translate((-(x + width / 2)) / oxDivider, 0);
                var final = compose(trans, mat);
                target.current.style.transform = toString(final);

                // props.onBounceBackEnded?.(target.current.style.transform );

                setTimeout(() => {
                    target.current.style.transition = "";
                }, 500);
            } else if (x + width / 2 > window.innerWidth) {
                target.current.style.transition = "transform 500ms";
                target.current.style.transitionTimingFunction = "ease-in";

                var mat = fromString(target.current.style.transform);
                var trans = translate(- ((x + width / 2) - window.innerWidth) / oxDivider, 0);
                var final = compose(trans, mat);
                target.current.style.transform = toString(final);

                // props.onBounceBackEnded?.(target.current.style.transform );

                setTimeout(() => {
                    target.current.style.transition = "";
                }, 500);
            } else if (y + height / 2 < 0) {
                props.onBounceBackStarted?.(target.current.style.transform);
                target.current.style.transition = "transform 500ms";
                target.current.style.transitionTimingFunction = "ease-in";

                var mat = fromString(target.current.style.transform);
                var trans = translate(0, (-(y + height / 2)) / oyDivider);
                var final = compose(trans, mat);
                target.current.style.transform = toString(final);

                props.onBounceBackEnded?.(final, width, height, target);

                setTimeout(() => {
                    target.current.style.transition = "";
                }, 500);
            } else if (y + height / 2 > window.innerHeight) {
                target.current.style.transition = "transform 500ms";
                target.current.style.transitionTimingFunction = "ease-in";

                var mat = fromString(target.current.style.transform);
                var trans = translate(0, - ((y + height / 2) - window.innerHeight) / oyDivider);
                var final = compose(trans, mat);
                target.current.style.transform = toString(final);

                // props.onBounceBackEnded?.(target.current.style.transform );

                setTimeout(() => {
                    target.current.style.transition = "";
                }, 500);
            }
        }
    }

    function GetMatrixScale(mat) {
        return Math.sqrt(mat.a * mat.a + mat.b * mat.b)
    }

    const pointerdown_handler = event => {
        props.onPointerDown?.();
    }

    useEffect(() => {
        ref.current.style.zIndex = GetMaxZIndex() + 1;
        ref.current.addEventListener('pointerdown', pointerdown_handler, false);
    }, [])

    useEffect(() => {
        if(!open && reposition){
            ref.current.style.transform = `matrix(1, 0, 0, 1, ${x}, ${y})`
        }
        if(open){
            ref.current.style.zIndex = GetMaxZIndex() + 1;
            if(reposition){
                ref.current.style.transform = `matrix(1, 0, 0, 1, ${x}, ${y})`
            }
        }
    }, [open])

    return (
        <div ref={ref} style={{ transition:"transform 0.5s", position: 'absolute', width: "10px", height: "10px", transform: `matrix(1, 0, 0, 1, ${x}, ${y})`, backgroundColor: "transparent" }}>
            {children}
        </div>
    );
})

export default CustomMultitouchComponent;